export default "__VITE_ASSET__CkW6E5OA__"